import React from 'react';
import PatientRegister from './pages/PatientRegister';

function App() {
  return <PatientRegister />;
}

export default App; 